/**
 * Environment variables (Vite injects these at build time).
 *
 * Default URLs are empty (relative) → requests go to the same origin that
 * served the SPA. Combined with the Nginx reverse-proxy in apps/web/nginx.conf,
 * this means production deployment is "single-origin":
 *
 *   Browser → http://monitor.company.local/api/*  →  Nginx → cm-server:3000
 *   Browser → http://monitor.company.local/socket.io/*  →  Nginx → cm-server:3000
 *   Browser → http://monitor.company.local/screenshots/*  →  Nginx → cm-server:3000
 *
 * Override VITE_API_URL / VITE_SOCKET_URL in dev if pointing to a remote server.
 */
const env = {
  /** REST API origin. Empty → use relative (Nginx proxied). */
  API_URL: import.meta.env.VITE_API_URL ?? '',
  /** Socket.IO origin. Empty → use relative. */
  SOCKET_URL: import.meta.env.VITE_SOCKET_URL ?? '',
  ENABLE_MOCKS: import.meta.env.VITE_ENABLE_MOCKS === 'true',
  DEV: import.meta.env.DEV,
  PROD: import.meta.env.PROD,
} as const

export const config = env
export type AppConfig = typeof env